const routes = [
  // {
  //   path: "/operationTools",
  //   name: authCodeMap.operationTools,
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/operationTools/questionnaire",
  //   meta: {
  //     title: "运营工具",
  //     hidden: false,
  //     icon: "tree",
  //     authCode: authCodeMap.operationTools,
  //   },
  //   children: [
  //     {
  //       path: "questionnaire",
  //       name: authCodeMap.operationTools_questionnaire,
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/index.vue"),
  //       meta: {
  //         title: "运营工具_问卷",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.operationTools_questionnaire,
  //       },
  //     },
  //     {
  //       path: "addQuestion",
  //       name: "operationTools_addQuestion",
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/addQuestion.vue"),
  //       meta: {
  //         title: "新增题目",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: "operationTools_questionBank_addBtn",
  //       },
  //     },
  //     {
  //       path: "catalogManage",
  //       name: "operationTools_catalogManage",
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/QuestionCatalogManagePage.vue"),
  //       meta: {
  //         title: "分类管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: "operationTools_catalogManage",
  //       },
  //     },
  //     {
  //       path: "questionnaire/answerSheetPage",
  //       name: authCodeMap.questionnaire_answerSheetPage,
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/answerSheetPage.vue"),
  //       meta: {
  //         title: "运营工具_问卷_答卷",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.questionnaire_answerSheetPage,
  //       },
  //     },
  //     {
  //       path: "questionnaire/answerSheetPage/answerSheetDetail",
  //       name: authCodeMap.questionnaire_answerSheetDetail,
  //       component: (): any => import("@/modules/operationTools/pages/questionnaire/answerSheetDetail.vue"),
  //       meta: {
  //         title: "运营工具_问卷_答卷详情",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.questionnaire_answerSheetDetail,
  //       },
  //     },
  //     {
  //       path: "questionnaireEdit",
  //       name: authCodeMap.questionnaire_edit,
  //       component: (): any => import("@/modules/operationTools/pages/questionnaireEdit/index.vue"),
  //       meta: {
  //         title: "运营工具_问卷设置",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.questionnaire_edit,
  //       },
  //     },
  //     {
  //       path: "measurementHeight",
  //       name: authCodeMap.operationTools_measurementHeight,
  //       component: () => import("@/modules/operationTools/pages/measurementHeight/index.vue"),
  //       meta: {
  //         title: "运营工具_身高测评",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.operationTools_measurementHeight,
  //       },
  //     },
  //     {
  //       path: "measurementHeight/dataList",
  //       name: authCodeMap.operationTools_measurementHeight_dataList,
  //       component: () => import("@/modules/operationTools/pages/measurementHeight/list/index.vue"),
  //       meta: {
  //         title: "运营工具_身高测评_数据列表",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.operationTools_measurementHeight_dataList,
  //       },
  //     },
  //     {
  //       path: "measurementHeight/detail",
  //       name: authCodeMap.operationTools_measurementHeight_detail,
  //       component: () => import("@/modules/operationTools/pages/measurementHeight/detail/index.vue"),
  //       meta: {
  //         title: "运营工具_身高测评_详情",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.operationTools_measurementHeight_detail,
  //       },
  //     },
  //   ],
  // },
];
export default routes;